function GenespLI() {
  return (
    <div>
      <li className="bullet-item">
        The pLI, defined as the probability of being loss-of-function intolerant, is a gene constraint metric
        provided by the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="https://gnomad.broadinstitute.org/">
          GNOMAD
        </a>{' '}
        consortium. A gene constraint metric aims at measuring how the naturally occurring LoF (loss of
        function) variation has been depleted from a gene by natural selection (in other words, how intolerant
        is a gene to LoF variation). LoF intolerant genes have a high pLI value (&gt;=0.9), while LoF tolerant
        genes have low pLI values (&lt;=0.1). The LoF variants considered are nonsense and essential splice
        site variants.
      </li>
    </div>
  );
}

export default GenespLI;
